import React from 'react';
import { Badge, Button, Table } from 'reactstrap';
import moment from 'moment';
import { partial } from '../../../util/translation/translation';

const STATUS_COLORS = {
  SCHEDULED: 'info',
  SENDING: 'warning',
  SENT: 'success',
  FAILED: 'danger',
};

// Emails sent to everyone supporting the plan (guests included), newest first
const PlanEmailHistory = ({ messages, onCancel }) => {
  const g = partial('goalSponsor');

  return (
    <div className="mt-4">
      <h5 className="mb-2">{g('emailHistory')}</h5>
      {messages.length === 0 ? (
        <p className="text-muted">{g('noEmailsYet')}</p>
      ) : (
        <Table responsive striped size="sm">
          <thead>
            <tr>
              <th>{g('emailSubject')}</th>
              <th>{g('emailStatus')}</th>
              <th>{g('emailWhen')}</th>
              <th>{g('emailRecipients')}</th>
              <th />
            </tr>
          </thead>
          <tbody>
            {messages.map((message) => (
              <tr key={message.id}>
                <td>{message.title}</td>
                <td>
                  <Badge color={STATUS_COLORS[message.status] || 'secondary'}>
                    {g(`emailStatus${message.status}`)}
                  </Badge>
                </td>
                <td>
                  {moment(
                    message.sentAt || message.scheduledDate || message.createdAt
                  ).format('YYYY-MM-DD HH:mm')}
                </td>
                <td>
                  {message.status === 'SENT' ? message.recipientCount : '–'}
                </td>
                <td className="text-right">
                  {message.status === 'SCHEDULED' && (
                    <Button
                      size="sm"
                      color="danger"
                      outline
                      className="mb-0"
                      onClick={() => onCancel(message.id)}
                    >
                      {g('cancelScheduledEmail')}
                    </Button>
                  )}
                </td>
              </tr>
            ))}
          </tbody>
        </Table>
      )}
    </div>
  );
};

export default PlanEmailHistory;
